import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appDecimalOnly]',
  standalone: true,
})
export class DecimalOnlyDirective {
  private allowedKeys = [
    'Backspace',
    'Tab',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
  ];

  @HostListener('beforeinput', ['$event'])
  onBeforeInput(event: InputEvent) {
    const input = event.target as HTMLInputElement;
    const currentValue = input.value;
    const data = event.data;
    if (data === ',') {
      event.preventDefault();
      if (!currentValue.includes('.')) {
        const start = input.selectionStart || 0;
        const end = input.selectionEnd || 0;
        input.value = currentValue.substring(0, start) + '.' + currentValue.substring(end);
        input.selectionStart = input.selectionEnd = start + 1;
        input.dispatchEvent(new Event('input'));
      }
      return;
    }

    // Allow digits
    if (data && /^[0-9]$/.test(data)) {
      return;
    }

    // Allow decimal point only if there isn't one already
    if (data === '.') {
      if (currentValue.includes('.') || currentValue.includes(',')) {
        event.preventDefault();
      }
      return;
    }

    // Block any other input
    if (data) {
      event.preventDefault();
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Dead') {
      event.preventDefault();
      return;
    }

    const input = event.target as HTMLInputElement;
    const currentValue = input.value;

    // Allow control keys
    if (this.allowedKeys.includes(event.key)) {
      return;
    }

    // Allow digits
    if (/^[0-9]$/.test(event.key)) {
      return;
    }

    // Convert comma to dot
    if (event.key === ',') {
      event.preventDefault();
      if (!currentValue.includes('.')) {
        const start = input.selectionStart || 0;
        const end = input.selectionEnd || 0;
        input.value = currentValue.substring(0, start) + '.' + currentValue.substring(end);
        input.selectionStart = input.selectionEnd = start + 1;
        input.dispatchEvent(new Event('input'));
      }
      return;
    }

    // Allow decimal point only if there isn't one already
    if (event.key === '.') {
      if (!currentValue.includes('.') && !currentValue.includes(',')) {
        return;
      }
    }

    event.preventDefault();
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Replace comma with dot for consistency
    value = value.replace(',', '.');

    // Remove any characters that aren't digits or decimal point
    const sanitized = value.replace(/[^0-9.]/g, '');

    // Ensure only one decimal point
    const parts = sanitized.split('.');
    let finalValue = parts[0];
    if (parts.length > 1) {
      finalValue += '.' + parts.slice(1).join('');
    }

    if (input.value !== finalValue) {
      input.value = finalValue;
      input.dispatchEvent(new Event('input'));
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedText = event.clipboardData?.getData('text') || '';
    // Allow paste if it's a valid decimal number
    if (!/^[0-9]*[.,]?[0-9]*$/.test(pastedText)) {
      event.preventDefault();
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
  }
}
